import React from 'react';
import { useRouteError, Link } from 'react-router-dom';
import { Frown } from 'lucide-react';
import './index.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  const is404 = error?.status === 404;

  return (
    <div className="app-container" style={{ minHeight: '100vh', justifyContent: 'center' }}>
      <div className="card glass" style={{ maxWidth: '500px', padding: '50px', textAlign: 'center', margin: '20px' }}>
        <Frown size={64} color="var(--color-primary)" style={{ marginBottom: '20px' }} />
        <h1>{is404 ? '404' : 'Oops!'}</h1>
        <p className="subtitle">
          {is404 ? "Looks like you took a wrong turn." : "Something went wrong under the hood."}
        </p>
        <p className="funny-text" style={{ marginBottom: '30px' }}>
          {is404 
            ? "Even I don't have a map for this part of the portfolio." 
            : "The hamsters powering the server might have tripped."}
        </p>
        
        {error?.statusText || error?.message ? (
          <p style={{ opacity: 0.6, fontSize: '0.9rem', marginBottom: '30px', wordBreak: 'break-word' }}>
            <i>{error.statusText || error.message}</i>
          </p>
        ) : null}
        
        <Link to="/" className="btn-primary" style={{ display: 'inline-block' }}>
          Take Me Home
        </Link>
      </div>
    </div>
  );
}

